import { Card, CardContent } from '@/components/ui/card'
import { cn } from '@/lib/utils'
import { useProjectComments } from '@/api/hooks'
import { CommentForm, CommentList } from '@/components/comments'

export function POCommentsCard({
  projectUuid,
  poUuid,
  poNumber,
  className,
}: {
  projectUuid: string
  poUuid: string
  poNumber: string
  className?: string
}) {
  // Same cached query CommentList reads; only used to tell whether this PO has comments.
  const { data: comments, isLoading, error } = useProjectComments(projectUuid)
  const empty =
    !isLoading &&
    !error &&
    !comments?.some((comment) =>
      comment.mentions.some(
        (mention) => mention.entity_type === 'purchase_order' && mention.entity_uuid === poUuid,
      ),
    )
  const list = (
    <CommentList
      projectUuid={projectUuid}
      filterMention={{ entity_type: 'purchase_order', entity_uuid: poUuid }}
    />
  )
  return (
    <Card className={cn('gap-0 py-0', className)}>
      <CardContent className="space-y-3 p-4">
        <h3 className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
          PO Comments
        </h3>
        <CommentForm
          projectUuid={projectUuid}
          contextMention={{
            entity_type: 'purchase_order',
            entity_uuid: poUuid,
            display_text: poNumber,
          }}
        />
        {empty ? (
          <>
            {/* Below lg the empty state is one quiet line instead of the tall illustrated block. */}
            <p className="text-xs text-muted-foreground lg:hidden">No comments on this PO yet</p>
            <div className="max-lg:hidden">{list}</div>
          </>
        ) : (
          list
        )}
      </CardContent>
    </Card>
  )
}
